import { createAction } from 'redux-actions'

export const setStore = createAction('MY_STORE/SET_STORE_DATA')
